module.exports = __webpack_public_path__ + "ptc_nakagawa_H2_2.f1348877.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H2_2.jpg
// module id = kbZ2
// module chunks = 0